import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* 任务弹框组件
 * <component-reward-tool-box :task="task"></component-reward-tool-box>
 */
export default {
  name: "reward_tool_box",
  data: function data() {
    return {
      showBox: false,
      //弹框
      showOutAnimation: false //展示关闭弹框动画
    };
  },

  props: {
    task: {
      default: {}
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    window.componentCenter.rewardToolBox = this;
    console.log("ycf组件初始化：rewardToolBox");
    if (!localStorage.getItem("reward_tool_box_" + this.task.taskId)) {
      this.$nextTick(function () {
        this.showBox = true;
        $(".scroll-area").css("overflow-y", "hidden");
        localStorage.setItem("reward_tool_box_" + this.task.taskId, true);
      });
    }
  },
  methods: {
    //隐藏弹框
    hideBox: function hideBox() {
      var that = this,
        timer = null;
      this.showOutAnimation = true;
      timer = setTimeout(function () {
        clearTimeout(timer);
        that.showOutAnimation = false;
        that.showBox = false;
        $(".scroll-area").css("overflow-y", "");
      }, 200);
    },
    //跳转到出单任务详情页
    goTaskDetailsPage: function goTaskDetailsPage() {
      var that = this;
      if (that.task.type == 4) {
        //任务详情页
        window.location.href = "/front/promoter/saleAward?weChatId=1" + "&taskId=" + that.task.taskId;
      } else {
        console.log("错误任务类型！");
      }
    }
  }
};